import { Injectable } from '@angular/core';
import { forkJoin, Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { SalesTeamSelectorService } from '../../../../../../data-services/sales-team-selector-service';
import { UsersService } from '../../../../../../data-services/users.service';
import { DataFilterDisplayService } from '../../interface';

@Injectable({ providedIn: 'root' })
export class SalesPersonOptionsDisplayService implements DataFilterDisplayService {
  constructor(
    protected readonly usersService: UsersService,
    private readonly salesTeamsService: SalesTeamSelectorService,
  ) {}
  getDisplay(value: string | string[]): Observable<string> {
    if (typeof value === 'string') {
      return of('');
    }
    const salesTeams$ = this.salesTeamsService.getMulti(value).pipe(
      catchError(() => of([])), // value might be salesperson ids so we need to supress the error here
    );
    const salespersonIds$ = this.usersService.getUsersById(value).pipe(
      catchError(() => of([])), // value might be sales team ids so we need to supress the error here
      map((users) => users.filter((u) => !!u)),
    );

    return forkJoin([salespersonIds$, salesTeams$]).pipe(
      map(([salesPeople, salesTeams]) => [
        ...value.map((salesPersonId) => this.usersService.getUserDisplay(salesPeople || [], salesPersonId)),
        ...salesTeams.filter((team) => value.includes(team.groupId)).map((team) => team.teamName),
      ]),
      map((x) => x.filter((y) => y !== '')),
      map((names) => `<b>${names.join(', ')}</b>`),
    );
  }
}
